import mock from 'src/utils/mock';

mock.onAny().passThrough();